@if (routingParams(); as routingParams) {
  @let hasParams = !!routingParams;
  @let isZoomed = !zoomed();
  @let showMenuBar = appMenuBarShown();
  @let navLinks = navigationLinks();
  @if (hasParams) {
    <aside class="navigation-bar--side" [class.active]="isZoomed">
      <div class="navigation-bar--side__details">
        <nav class="full-navigation non-selectable">
          <div class="user">
            <div class="user__image non-selectable" [title]="'user-photo' | translate">
              @if (elementLoaded) {
                <img
                  animate.enter="fade-in"
                  ngSrc="assets/img/app/avatar.webp"
                  fill
                  (error)="elementLoaded = false"
                  [alt]="'user-photo' | translate" />
              }
              @if (!elementLoaded) {
                <nz-skeleton-element animate.enter="fade-in" nzType="image" [nzActive]="true" />
              }
            </div>
            <div class="user__details">
              <h2 class="user__details__name">John Smith</h2>
              <p class="user__details__mail">johnsmith&#64;gmail.com</p>
            </div>
          </div>
          <section class="full-navigation__navigation">
            <h2>{{ 'navigation' | translate }}</h2>
            <div class="links">
              @for (menuItem of navLinks; track menuItem.route) {
                <a routerLinkActive="link-active" [routerLink]="menuItem.route">
                  {{ menuItem?.translatePath | translate }}
                </a>
              }
            </div>
          </section>
          <section class="full-navigation__other">
            <h2>{{ 'account' | translate }}</h2>
            <div class="links">
              <a [routerLink]="pages.SETTINGS" routerLinkActive="link-active">{{ 'settings' | translate }}</a>
              <a [routerLink]="pages.SAVED_CARDS" routerLinkActive="link-active">{{ 'saved-cards' | translate }}</a>
              <a [routerLink]="pages.ORDER_HISTORY" routerLinkActive="link-active">{{ 'order-history' | translate }}</a>
            </div>
          </section>
          <section class="full-navigation__contact">
            <div class="links">
              <a [routerLink]="pages.FEEDBACK" routerLinkActive="link-active">{{ 'give-feedback' | translate }}</a>
              <a [routerLink]="pages.CONTACT" routerLinkActive="link-active">{{ 'contact' | translate }}</a>
              <a [routerLink]="pages.TERMS_AND_CONDITIONS" routerLinkActive="link-active">{{ 'terms-and-conditions' | translate }}</a>
              <a [routerLink]="pages.FAQ" routerLinkActive="link-active">{{ 'faq' | translate }}</a>
            </div>
          </section>
        </nav>
      </div>
    </aside>
  }
  <main [class.active]="isZoomed" class="clickable" tabindex="0" (click)="zoomInApp($event)" (keyup)="zoomInApp($event)">
    @if (hasParams) {
      <app-menu-icon tabindex="0" (click)="toggleZoom($event)" class="clickable" />
    }
    <div class="router">
      <router-outlet #outlet="outlet" />
    </div>
    @if (showMenuBar) {
      <app-menu-bar animate.enter="slide-in-up" animate.leave="slide-out-up" class="non-selectable navigation-bar--bottom" />
    }
  </main>
}

<!-- Cookie Consent Banner -->
<cookie-banner />
